interface Obj {
  id: number;
  [key: string]: any;
}

export const getUniqueElemsFromFirstArray = <O extends Obj>(
  arr: O[],
  arr1: number[]
) => arr.filter((elem) => !arr1.includes(elem.id));
